import { Player } from '../Player';
import ChunkBase from './ChunkBase';
import EntityContainer from './EntityContainer';
import { BodyTypes } from './LevelManager';
import { RelicName, RelicNameValues } from './relics/relic';
import { GameDataHandler } from './../GameDataHandler';
import { RunSettingsHandler } from './RunSettingsHandler';
import { app } from '../core/App';

export default class EntityRelic extends EntityContainer {
  protected chunk: ChunkBase | undefined;
  protected isInitialised: boolean;
  protected hasCollided: boolean;
  protected relicName: RelicNameValues;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);

    this.isInitialised = false;
    this.hasCollided = false;

    this.relicName = RelicName.None;
  }

  public init(relicName: RelicNameValues) {
    this.relicName = relicName;

    if (this.isInitialised) return;

    this.injectMatter(this);
    this.isInitialised = true;
  }

  public bindChunk(chunk: ChunkBase) {
    this.chunk = chunk;
  }

  public reset() {
    this.alpha = 1;
    this.scale = 1;
    this.setVisible(true);
    this.setActive(true);

    this.hasCollided = false;
  }

  // public recycle(removeFromChunk: boolean = false) {
  //   console.log('Recycling Smashable!');

  //   this.scene.tweens.killTweensOf(this);
  //   this.setVisible(false);
  //   this.setActive(false);
  //   this.setPosition(-1000, 0);

  //   if (removeFromChunk) this.chunk?.removeEntity(this);
  //   this.chunk = undefined;
  // }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    let matterSprite = this.scene.matter.add.gameObject(target, {
      label: BodyTypes.Relic,
      isStatic: true,
      isSensor: true,
      onCollideCallback: this.onCollision.bind(this)
    }) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollision(pair: MatterJS.IPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyA as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyA as MatterJS.BodyType, (pair.bodyA as MatterJS.BodyType).gameObject);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Player && (pair.bodyB as MatterJS.BodyType).gameObject instanceof Player) {
      this.onCollisionWithPlayer(pair.bodyB as MatterJS.BodyType, (pair.bodyB as MatterJS.BodyType).gameObject);
    }
  }

  protected onCollisionWithPlayer(body: MatterJS.BodyType, player: Player) {
    this.hasCollided = true;

    // Player collects relic.
    console.log('Relic collected!');
    GameDataHandler.collectRelic(this.scene, this.relicName);
    RunSettingsHandler.activateRelic(this.scene, this.relicName);

    this.scene.add.tween({
      targets: this,
      y: '+=-150',
      alpha: { from: 1, to: 0, duration: 250 },
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.destroy,
      onCompleteScope: this
    });

    app.audioHandler.playSound(this.scene, 'SndRelicCollect', 'sfx');
  }
}
